// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vrshqdsjmiexlewrzcbg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZyc2hxZHNqbWlleGxld3J6Y2JnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA2NzY3NTIsImV4cCI6MjA3NjI1Mjc1Mn0.bJLz01xM0m6UfcOGBNUj1M3SW098HoWr8HblMFn1MG4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});